import { Space } from "antd";
// project import
import Profile from "./Profile";
import Notification from "./Notification";
import ThemeToggle from "@/components/ThemeToggle";
import FontSizeToggle from "@/components/FontSizeToggle";
import FullscreenToggle from "@/components/FullscreenToggle";
import { useTheme } from "@/App";

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = ({ isMobile = false, isTablet = false }) => {
  const { isDark, toggleTheme } = useTheme();

  // Mobile view - theme and profile only
  if (isMobile) {
    return (
      <Space size="small" className="flex items-center">
        <ThemeToggle isDark={isDark} onToggle={toggleTheme} />
        <Profile isMobile={isMobile} />
      </Space>
    );
  }

  // Tablet view - Condensed icons
  if (isTablet) {
    return (
      <Space size="small" className="flex items-center">
        <ThemeToggle isDark={isDark} onToggle={toggleTheme} />
        <FontSizeToggle />
        <FullscreenToggle />
        <Notification isTablet={isTablet} />
        <Profile isTablet={isTablet} />
      </Space>
    );
  }

  // Desktop view - Full layout
  return (
    <Space size={8} className="flex items-center">
      <ThemeToggle isDark={isDark} onToggle={toggleTheme} />
      <FontSizeToggle />
      <FullscreenToggle />
      <Notification />
      <Profile />
    </Space>
  );
};

export default HeaderContent;
